if (!customElements.get('astro-light-demo')) {
  customElements.define('astro-light-demo', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.slider = this.querySelector('[data-kelvin-slider]');
      if (!this.slider) return;
      this.brightness = this.querySelector('[data-brightness-slider]');
      this.brightness?.addEventListener('input', () => this.updateBrightness(), {signal:this.abort.signal});
      this.updateBrightness();
      this.current = 3000;
      this.target = 3000;
      this.frame = 0;
      this.last = 0;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.slider.addEventListener('input', () => this.update(), {signal: this.abort.signal});
      this.querySelectorAll('[data-kelvin]').forEach(button => {
        button.addEventListener('click', () => {
          this.slider.value = button.dataset.kelvin;
          this.update();
        }, {signal: this.abort.signal});
      });
      this.update();
    }
    paint(kelvin) {
      this.querySelector('[data-room-neutral]').style.opacity = Math.min(1, Math.max(0, (kelvin - 2700) / 1800));
      this.querySelector('[data-room-cool]').style.opacity = Math.min(1, Math.max(0, (kelvin - 4500) / 2000));
    }
    animate(time) {
      const elapsed = this.last ? Math.min(time - this.last, 64) : 16;
      this.last = time;
      this.current += (this.target - this.current) * (1 - Math.exp(-elapsed / 65));
      if (Math.abs(this.target - this.current) < 1) {
        this.current = this.target;
        this.paint(this.current);
        this.frame = 0;
        this.last = 0;
        return;
      }
      this.paint(this.current);
      this.frame = requestAnimationFrame(t => this.animate(t));
    }
    update() {
      this.target = Number(this.slider.value);
      const kind = this.target < 3750 ? 'Luz cálida' : this.target > 5250 ? 'Luz fría' : 'Luz neutra';
      const set = (name, text) => { this.querySelector('[data-' + name + ']').textContent = text; };
      set('kelvin-value', this.target + ' K');
      set('kelvin-scene-value', this.target + ' K');
      set('kelvin-scene-kind', kind);
      set('kelvin-heading', this.target < 3750 ? 'Cálida y acogedora' : this.target > 5250 ? 'Fresca y definida' : 'Neutra y equilibrada');
      set('kelvin-description', this.target < 3750 ? 'Un tono más dorado para imaginar un ambiente cálido y relajado.' : this.target > 5250 ? 'Una apariencia más fría para comparar una sensación fresca y definida.' : 'Un tono intermedio para imaginar una apariencia más equilibrada.');
      this.slider.setAttribute('aria-valuetext', this.target + ' kelvin, ' + kind.toLowerCase());
      this.querySelectorAll('[data-kelvin]').forEach(b => b.setAttribute('aria-pressed', String(Number(b.dataset.kelvin) === this.target)));
      if (this.reduced.matches) {
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = 0;
        this.last = 0;
        this.current = this.target;
        this.paint(this.current);
      } else if (!this.frame) {
        this.frame = requestAnimationFrame(t => this.animate(t));
      }
    }
    updateBrightness() {
      if (!this.brightness) return;
      const level = Number(this.brightness.value);
      this.querySelector('[data-brightness-value]').textContent = level + ' %';
      this.brightness.setAttribute('aria-valuetext',level + ' por ciento, intensidad de ejemplo');
      this.style.setProperty('--demo-brightness',String(.2 + .8 * level / 100));
    }
    disconnectedCallback() {
      this.abort?.abort();
      if (this.frame) cancelAnimationFrame(this.frame);
    }
  });
}
